var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoderj(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.13 5.70996L13.2 0.779968C12.7 0.279968 12.02 0 11.31 0H6.92004C3.61004 0 0.920044 2.69 0.920044 6V12C0.920044 15.31 3.61004 18 6.92004 18H12.92C16.23 18 18.92 15.31 18.92 12V7.60999C18.92 6.89999 18.64 6.21997 18.14 5.71997L18.13 5.70996ZM12.66 3.07001L15.85 6.26001H14.26C13.38 6.26001 12.66 5.59001 12.66 4.76001V3.07001ZM12.91 15.99H6.91003C4.70003 15.99 2.91003 14.2 2.91003 11.99V5.98999C2.91003 3.77999 4.70003 1.98999 6.91003 1.98999H10.65V4.76001C10.65 6.69001 12.27 8.26001 14.25 8.26001H16.9V11.99C16.9 14.2 15.11 15.99 12.9 15.99H12.91Z",
    fill: "#009CB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoderj);
export default __webpack_public_path__ + "static/media/soderj.63154e410da655f0920783ca457d8130.svg";
export { ForwardRef as ReactComponent };